/**
 * Global Depth Provider — locked to PLAIN ENGLISH.
 *
 * Feb 2026: per founder direction, the technical / plain-English
 * toggle was retired. Every reader — student, clinician, community —
 * gets the same plain-language rendering. Pages can still call
 * `useDepth()` and read `depth === "plain"`; legacy `depthToLevel()`
 * returns "community" to satisfy any /api?level=… consumers.
 *
 * No localStorage, no per-tab state. `setDepth` is a no-op.
 */
import { createContext, useContext } from "react";

const VALUE = {
  depth: "plain",
  setDepth: () => {},
};

const DepthCtx = createContext(VALUE);

export function DepthProvider({ children }) {
  return <DepthCtx.Provider value={VALUE}>{children}</DepthCtx.Provider>;
}

export function useDepth() {
  return useContext(DepthCtx);
}

export function depthToLevel(_depth) {
  return "community";
}
